module.exports = __webpack_public_path__ + "img/myorder.f699273c.png";